module.exports = __webpack_public_path__ + "img/logo-suzuki.27ea571.png";